import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";

function ProfileFormSuccess({setView}) {
  
    const navigate = useNavigate();
  return (
     <Box
           sx={{
             height: "50vh",
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
             flexDirection: "column",
             textAlign: "center",
           }}
         >
           <Typography variant="h4" color="primary" gutterBottom>
             Thank you!
           </Typography>
           <Typography variant="body1">
             Your profiling form has been submitted successfully.
           </Typography>
           <button className="btn btn-primary mt-3" onClick={() => setView("overview")}>
             Go Back
           </button>
         </Box>
  );
}

export default ProfileFormSuccess;
